import {initReducerContext} from '@someok/simple-reducer-store';

import actions from './actions';

const initialState = {
    clientAppId: null,
    clientApp: {},
    // 是否存在需绑定 App 的 Api
    hasBindAppApi: false,
    reload: () => {},
};

const [useClientAppStore, ClientAppStoreProvider, ClientAppContext] = initReducerContext(
    initialState,
    actions
);

export {useClientAppStore, ClientAppStoreProvider, ClientAppContext};
